import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import { forwardRef } from 'react';
import { InnerContext } from './Inner.context.js';
import { jsx } from 'react/jsx-runtime';
import { TableDataCell } from './DataCell/DataCell.js';
import { TableHeaderCell } from './HeaderCell/HeaderCell.js';

var Cell = /*#__PURE__*/forwardRef(function Cell(_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsx(InnerContext.Consumer, {
    children: function children(_ref2) {
      var variant = _ref2.variant,
        sticky = _ref2.sticky;
      switch (variant) {
        case 'head':
          return /*#__PURE__*/jsx(TableHeaderCell, _objectSpread({
            ref: ref,
            sticky: sticky
          }, rest));
        default:
        case 'body':
          return /*#__PURE__*/jsx(TableDataCell, _objectSpread({
            ref: ref
          }, rest));
      }
    }
  });
});

export { Cell };
